
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineThreeway as ObiGenericLineThreewayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-threeway.js';
 
 
 

 
 export const ObiGenericLineThreeway = createComponent({
   react: React,
   tagName: 'obi-generic-line-threeway',
   elementClass: ObiGenericLineThreewayElement,
   events: {
     
   }
  });
 
 